import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import { store, initStore } from './store/index'
import './plugins'
import * as filters from './filters'
import './assets/styles/index.scss'
import ElementUI from 'element-ui' // 全局引入element
import 'element-ui/lib/theme-chalk/index.css'
import { urls } from '@api/allapi'
import './components/drag.js'

import Video from 'video.js'
import 'video.js/dist/video-js.css'
import animate from "animate.css"
import wow from 'wowjs'// 全局导入wow.js
Vue.prototype.$wow = wow // 全局注册到Vue实例中

Vue.prototype.$video = Video // 引入Video播放器

Vue.config.productionTip = false

/* 定义全局过滤器 */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(ElementUI)
Vue.prototype.$baseUrl = urls
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}
new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    initStore()
  }
}).$mount('#app')
